import { IdentifierDTO } from '@zazume/zzm-base';

import { PaginationOptions } from '#/hooks';
import { MoveInHomeInsurancePlan } from '#/models/application/MoveIn';
import { Supplies } from '#/models/supplies/Supplies';
import { UtilityStatesType, UtilityTypeType } from '#/models/supplies/types';
import { CreateSuppliesFormData } from '#/pages/supplies/components/forms/CreateSupplies.schema';

import { doDelete, doGet, doPost, doPut, EndpointBuilder, parserDataList, toPaginatedURL } from '../../helpers';
import { UtilityData } from '../application/models/UtilityData';

export const supplies = {
  delete: (id: IdentifierDTO) => doDelete(`/dashboard/supplies/${id}`),
  get: (id: IdentifierDTO) => () => doGet<Supplies>(`/dashboard/supplies/${id}`, Supplies.fromRaw),
  getPaginated: (organizationId: IdentifierDTO, params: EndpointBuilder) => (pagination: PaginationOptions) => () =>
    doGet<Supplies[]>(
      toPaginatedURL(`/dashboard/supplies/organization/${organizationId}${params.queryParams}`, pagination),
      parserDataList(Supplies.fromRaw)
    ),
  create: (formData: CreateSuppliesFormData) => doPost<Supplies>('/dashboard/supplies', formData, Supplies.fromRaw),
  getUtilityData: (utilityType: string) => () =>
    doGet<UtilityData[]>(`/dashboard/supplies/utility-data/${utilityType}`),
  getRequestedHomeInsurancePlans: (suppliesId: IdentifierDTO) => () =>
    doGet<MoveInHomeInsurancePlan[]>(`/dashboard/supplies/${suppliesId}/home-insurance-plans`),
  requestManagementSupplies: (suppliesId: IdentifierDTO) => body =>
    doPost<void>(`/dashboard/supplies/${suppliesId}/request-management-supplies`, body),
  initHomeInsurancePlans: (suppliesId: IdentifierDTO) => request =>
    doPost<void>(`/dashboard/supplies/${suppliesId}/home-insurance-plans/init`, request),
  issueHomeInsurancePlan: (suppliesId: IdentifierDTO) => (planUUID: string) =>
    doPost<void>(`/dashboard/supplies/${suppliesId}/home-insurance-plans/issue`, { planUUID }),
  dismissHomeInsurance: (suppliesId: IdentifierDTO) =>
    doDelete<void>(`/dashboard/supplies/${suppliesId}/home-insurance-plans/dismiss`),
  dismissLaterManagement: (suppliesId: IdentifierDTO) => () =>
    doPost<void>(`/dashboard/supplies/${suppliesId}/dismiss-later-management`),
  requestNoManagementSupplies: (suppliesId: IdentifierDTO) => () =>
    doPost<void>(`/dashboard/supplies/${suppliesId}/request-no-management-supplies`),
  retrySendUtilitiesToProvider: (suppliesId: IdentifierDTO) =>
    doPut(`/dashboard/supplies/${suppliesId}/resend-provider-utilities`),
  updateUtility: (suppliesId: IdentifierDTO) => (params: { type: UtilityTypeType; state: UtilityStatesType }) =>
    doPut(`/dashboard/supplies/${suppliesId}/state/utility/${params.type}`, {
      utilityState: params.state
    })
};
